import { FileSizeUnit } from 'src/types/enum/file-size-unit';

export const calculateFileSizeFromBytes = (
  value: number,
  unit: FileSizeUnit,
) => {
  switch (unit) {
    case FileSizeUnit.KB:
      return value / 1024;
    case FileSizeUnit.MB:
      return value / 1024 / 1024;
    case FileSizeUnit.GB:
      return value / 1024 / 1024 / 1024;
    default:
      return value;
  }
};
